import {
  ByIdPayload,
  FailByIdPayload,
  OperationReducerTypes,
  PayloadAction,
  uniqueActionType
} from '@industi/ngx-common';

export const OrderItemDeleteActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[order/item] Delete'),
  requestFail: uniqueActionType('[order/item] Delete fail'),
  requestSuccess: uniqueActionType('[order/item] Delete success'),
  requestClearErrors: uniqueActionType('[order/item] Delete clear errors'),
  requestClear: uniqueActionType('[order/item] Delete clear'),
};

export class OrderItemDeleteAction implements PayloadAction {
  readonly type = OrderItemDeleteActionTypes.request;

  constructor(public payload: ByIdPayload) {
  }
}

export class OrderItemDeleteFailAction implements PayloadAction {
  readonly type = OrderItemDeleteActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class OrderItemDeleteSuccessAction implements PayloadAction {
  readonly type = OrderItemDeleteActionTypes.requestSuccess;

  constructor(public payload: ByIdPayload) {
  }
}

export class OrderItemDeleteClearErrorsAction implements PayloadAction {
  readonly type = OrderItemDeleteActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}

export class OrderItemDeleteClearAction implements PayloadAction {
  readonly type = OrderItemDeleteActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}
